import React, { useState } from "react";

import bgImg from "../../images/bmg.jpg";
import "./footer.css";
const Footer = () => {
  return (
    <section>
      <div className="register">
        <div className="col-1">
          <h2>Contact Us</h2>
          <span>Contact us for any query</span>

          <form id="form" className="flex flex-col">
            <input type="text" placeholder="username" />
            <input type="text" placeholder="email" />
            <input type="text" placeholder="confirm email" />
            <input type="text" placeholder="mobile number" />

            <button className="btn">Submit</button>
          </form>
        </div>
        <div className="col-2">
          <div className="image-form">
            <img src={bgImg} alt="" />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Footer;
